import multi from './multi';
import multiHierarchy from './multi-hierarchy';
import single from './single';
import singleRadio from './single-radio';
import singleRadioHierarchy from './single-radio-hierarchy';
import topHierarchy from './top-hierarchy';
import lowHierarchy from './low-hierarchy';
import permissionLowHierarchy from './permission-low-hierarchy';

export default {
  single,
  multi,
  'single-radio': singleRadio,
  'single-radio-hierarchy': singleRadioHierarchy,
  'multi-hierarchy': multiHierarchy,
  'top-hierarchy': topHierarchy,
  'low-hierarchy': lowHierarchy,
  'permission-low-hierarchy': permissionLowHierarchy,
};
